/* assets/sticky-bar-early-trigger.js
   Controls sticky bar visibility based on scroll position (triggers when .coupon-banner--root fully scrolled)
   ------------------------------------------------------------------ */

(function() {
  'use strict';

  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    // Wait a tick for sections to render
    setTimeout(() => {
      initStickyBarBehavior();
    }, 100);
  }

  function initStickyBarBehavior() {
    const couponBanner = document.querySelector('.coupon-banner--root');
    const drawer = document.querySelector('.product-buy-buttons--drawer');
    
    if (!drawer) {
      return;
    }

    let drawerDisabled = false;
    let pendingOpen = false;

    // Open/close methods
    const openDrawer = () => {
      pendingOpen = true;
      if (!drawerDisabled) {
        drawer.setAttribute('aria-hidden', 'false');
      }
    };

    const closeDrawer = () => {
      pendingOpen = false;
      drawer.setAttribute('aria-hidden', 'true');
    };

    // If no coupon banner exists, use scroll-based trigger instead
    if (!couponBanner) {
      let lastScrollY = window.scrollY;
      
      const handleScroll = () => {
        const currentScrollY = window.scrollY;
        
        // Show sticky bar after scrolling down 300px
        if (currentScrollY > 300) {
          openDrawer();
        } else {
          closeDrawer();
        }
        
        lastScrollY = currentScrollY;
      };
      
      // Throttle scroll handler for performance
      let scrollTimeout;
      window.addEventListener('scroll', () => {
        if (scrollTimeout) return;
        scrollTimeout = setTimeout(() => {
          handleScroll();
          scrollTimeout = null;
        }, 50);
      }, { passive: true });
      
      // Initial check
      handleScroll();
    } else {
      // Main trigger: Show sticky bar when .coupon-banner--root is FULLY scrolled past
      // threshold: 0 means trigger when ANY part leaves viewport
      // We check boundingClientRect.bottom <= 0 to ensure it's FULLY scrolled past
      const couponBannerObserver = new IntersectionObserver(
        ([{ isIntersecting, boundingClientRect }]) => {
          // Show sticky bar when coupon banner has FULLY scrolled past the top
          if (!isIntersecting && boundingClientRect.bottom <= 0) {
            openDrawer();
          } 
          // Hide sticky bar when coupon banner comes back into view
          else if (isIntersecting) {
            closeDrawer();
          }
        },
        {
          threshold: 0,
          rootMargin: '0px 0px 0px 0px'
        }
      );

      // Start observing
      couponBannerObserver.observe(couponBanner);
    }

    // Listen for popup/drawer events that should disable sticky bar (applies to both trigger modes)
    window.addEventListener('theme:popup:opened', () => {
      drawerDisabled = true;
      drawer.setAttribute('aria-hidden', 'true');
    });

    window.addEventListener('theme:popup:closed', () => {
      drawerDisabled = false;
      if (pendingOpen) drawer.setAttribute('aria-hidden', 'false');
    });

    window.addEventListener('theme:drawer:left:opening', () => {
      drawerDisabled = true;
      drawer.setAttribute('aria-hidden', 'true');
    });

    window.addEventListener('theme:drawer:right:opening', () => {
      drawerDisabled = true;
      drawer.setAttribute('aria-hidden', 'true');
    });

    window.addEventListener('theme:drawer:left:closed', () => {
      drawerDisabled = false;
      if (pendingOpen) drawer.setAttribute('aria-hidden', 'false');
    });

    window.addEventListener('theme:drawer:right:closed', () => {
      drawerDisabled = false;
      if (pendingOpen) drawer.setAttribute('aria-hidden', 'false');
    });
  }
})();
